<ng-select [items]="orgs$ | async"
  bindLabel="name"
  bindValue="name"
  (change)="orgChanged($event)"
  [clearable]="false"
  [loading]="loading$ | async"
  [compareWith]="compareOrgs"
  [virtualScroll]="true"
  [(ngModel)]="selectedOrg">
  <ng-template ng-label-tmp let-item="item">
    {{ item.name }} @if (item.lms_name) {
    <span>({{item.lms_name}})</span>
    } ({{item.group_id}})
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.name + ' ' + (item.lms_name ? '(' + item.lms_name + ')' : '') }}
  </ng-template>
</ng-select>
